export interface User {
	name: string
}

export interface Racer {
	timeInSeconds: number,
	timeString: string,
	user: User
}

export interface GameType {
	abbreviation: string,
	name: string
}

export interface Race {
	id: number
    raceName: string
	raceNumber: number
    gameType: string
    raceStartTimestamp?: Date
    vod?: string
}

export interface BlindRace extends Race {
	creators: Creator[]
	raceNumber: number
	raceType: "SMW Kaizo Race"
	difficulty?: number
	patchFile?: string
	ratingSystem?: "1-10" | "standard"
}

export interface Podium {
	name: string
	raceId: number
	timeInMs: number
	userId: number
	nickname?: string
	isVerified?: boolean
}

export interface Creator {
	creatorId: number
	name: string
	raceId: number
	nickname?: string
}

export interface OldRace {
	creators: User[],
	difficulty: number,
	gameType: string,
	id: number,
	patchFile?: string,
	patchUrl?: string[],
	raceName: string,
	raceNumber: number,
	raceStartTimestamp?: Date,
	racers?: Racer[],
	raceType: string,
	ratingSystem: string,
	screenshots?: string[],
	vod: string,
}

export interface Event {
	creators: string[],
	gameType: GameType,
	name: string,
	patchFilename?: string,
	patchUrl?: string,
	raceTime?: Date,
	racers: Racer[],
	screenshots: string[],
	vodUrl: string,
}

export interface Week {
	[index: number]: OldRace[]
}

export interface Page {
	[index: number]: Week[] | Event[]
}

export interface Races {
	[index: string]: {
		maxPage: number
		pagination: Page[]
	}
}

export interface BlindKaizoRace {
	_id: string
	name?: string
	number: number
	raceStart: Date
	raceType: string
	isPublic: boolean
	needsAnnouncement: boolean
	game: {
		_id: string
		name: string
		abbreviation: string
	}
	patchFile?: string
	rating: {
		ratingSystem: string
		value?: number
		isOpen: boolean
	}
	creators: Array<string>
	racers: Array<{
		user: string
		timeMs?: number
		isVerified: boolean
		verifiedBy?: {
			_id: string
			twitchUsername?: string
			name?: string
			nickname?: string
		}
		skipRestream?: boolean
	}>
	vod?: {
		service?: string
		id?: string
	}
	images?: string[]
	createdAt?: Date
	updatedAt?: Date
}

export const formatTimeString = (timeMs: number): string => {
	const totalSeconds = Math.floor(timeMs / 1000)
	const hours = Math.floor(totalSeconds / 3600)
	const minutes = Math.floor((totalSeconds % 3600) / 60)
	const seconds = totalSeconds % 60
	const mm = minutes.toString().padStart(2, '0')
	const ss = seconds.toString().padStart(2, '0')
	if (hours >= 1) {
		return `${hours}:${mm}:${ss}`
	}
	return `${minutes}:${ss}`
}